var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"all"}},[_c('div',{attrs:{"id":"searchbar"}},[_c('SearchBar',{on:{"update-url":_vm.update}})],1),_c('div',{attrs:{"id":"playerdisplay"}},[_c('PlayerDisplay',{attrs:{"url":_vm.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }